module.exports = __webpack_public_path__ + "img/07岳晋琛.21a6af48.jpg";